var map = {
	"./accident.png": 6782,
	"./inspection.png": 6851,
	"./management.png": 1768,
	"./report.png": 1283,
	"./unsafeBehavior.png": 6553,
	"./unsafeBehavior_old.png": 3943,
	"./unsafeCondition.png": 1080
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9945;